import httpApiApplication from 'app/http/httpApiApplication';
import { type Taxpayer } from 'app/modules/Reports/TaxReturnList/types';

export const BaseUrlTax = '/taxes';
export const BaseUrlTaxRates = '/TaxRates';
export const BaseUrlTaxPeriodicity = '/TaxPeriodicity';
export const BaseUrlTaxpayer = '/taxpayers';

export const TaxpayerListPaging = (page: number, pageSize: number, params: any) => {
  return httpApiApplication.paginate<Taxpayer>(BaseUrlTaxpayer + '/paging', page, pageSize, params);
};
